module.exports = __webpack_public_path__ + "static/media/CNX-IT.11a9f1d1.txt";